/**
 * 화면 주소 만들기(경로 도우미) — 화면 표(router/table.ts · E-1)의 경로와 같은 모양을 기능 · 페이지가 쓴다.
 * 기능(features/*)은 router/ 를 import 하지 않으므로(CSG 4.3 ③) 도우미는 여기 두고, 화면 표가 다시 내보낸다.
 */
/** 관찰자(P3-S5)는 홈이 없다 — 공유 링크 없이 들어오면 FS-01-05 안내('링크로 열어 주세요') */
export const SHARE_HOME = "/share";
export const sharePath = (token: string) => `${SHARE_HOME}/${encodeURIComponent(token)}`;

export const homeFor = (role: "student" | "teacher" | "operator" | "org_admin" | "observer") =>
  role === "observer"
    ? SHARE_HOME
    : role === "teacher"
      ? "/teacher"
      : role === "operator"
        ? "/ops"
        : role === "org_admin"
          ? "/org/report"
          : "/home";

export const roomConsolePath = (roomId: string) => `/teacher/room/${encodeURIComponent(roomId)}`;

export const boardPath = (roomId: string) => `/board/${encodeURIComponent(roomId)}`;
export const scriptPath = (roomId: string) => `${roomConsolePath(roomId)}/script`;
export const sandboxPath = (roomId: string) => `${roomConsolePath(roomId)}/sandbox`;
export const assessPath = (roomId: string) => `${roomConsolePath(roomId)}/assess`;
export const relayPath = (roomId: string) => `${roomConsolePath(roomId)}/relay`;
/** 룸 id 를 모를 때(교사 홈 '영상 준비됨' — 닫힌 룸) 영상 탭은 코스 전체를 보인다 */
export const RECENT_ROOM = "recent";
export const videoPath = (roomId: string | null | undefined) =>
  `${roomConsolePath(roomId || RECENT_ROOM)}/video`;
/** P3-S4 교류 룸 초대·수락(FS-11-08) — 룸이 없으면 'recent' */
export const exchangePath = (roomId: string | null | undefined) =>
  `${roomConsolePath(roomId || RECENT_ROOM)}/exchange`;
export const ORG_REPORT_PATH = "/org/report";

export const playgroundPath = (courseId: string) =>
  `/teacher/course/${encodeURIComponent(courseId)}/playground`;

/** SR-NET-05 교사 학교망 진단(FS-C1-08) */
export const NETCHECK_PATH = "/teacher/netcheck";
